import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
} from '@sttedra_ui/framework';

import ReportsApiResponseModel from './reports.api-response-model.js';

// #region Globals
const {base} = useAxios();
const NO_TIMEOUT = 0; // No timeout
// #endregion

// #region Public functions
async function searchReport(searchParams = {},
  path,
  timeout = NO_TIMEOUT) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = '/' + path;

    const {data: response} = await base.post(url, searchModel, {
      timeout,
    });

    const {url: reportUrl} = response;

    const now = new Date();
    const report = new ReportsApiResponseModel({url: reportUrl, time: now});
    return report;
  } catch (err) {
    throw err;
  }
}
async function searchReportHTML(searchParams = {},
  path,
  timeout = NO_TIMEOUT) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = '/' + path;

    const {data: response} = await base.post(url, searchModel, {
      timeout,
    });

    const reportUrl = URL.createObjectURL(new Blob([response], {type: 'text/html;charset=utf-8'}));

    const now = new Date();
    const report = new ReportsApiResponseModel({url: reportUrl, time: now});
    return report;
  } catch (err) {
    throw err;
  }
}
async function searchReportById(id = 0,
  path,
  timeout = NO_TIMEOUT) {
  try {
    const url = '/' + path;
    const {data: response} = await base.post(url, {}, {
      timeout,
      params: {
        id,
      },
    });
    const {url: reportUrl} = response;
    const now = new Date();
    const report = new ReportsApiResponseModel({url: reportUrl, time: now});
    return report;
  } catch (err) {
    throw err;
  }
}
// #endregion

// #region Private functions
// ...
// #endregion

export {
  searchReport,
  searchReportHTML,
  searchReportById,
};
